import { useQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { RoleDetailContainerStaffUserCurrentDocument, RoleEditContainerStaffRoleDocument, StaffRole } from '../../../../generated.tsx';
import { useOid } from '../../../../hooks/useOid.ts';
import { ComponentQueryLoader } from '../../../shared/component-query-loader.tsx';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled } from '../../../shared/utils/queryOptions';
import { RoleDetail } from './role-detail.tsx';

interface RoleDetailContainerProps {}

export const RoleDetailContainer: React.FC<RoleDetailContainerProps> = () => {
  const { roleId } = useParams();
  const oid = useOid();
const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled(oid);

  const {
    data: staffUserCurrentData,
    loading: staffUserCurrentLoading,
    error: staffUserCurrentError
  } = useQuery(RoleDetailContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);

  const {
    data: roleData,
    error: roleDataError,
    loading: roleDataLoading
  } = useQuery(RoleEditContainerStaffRoleDocument, {
    variables: {
      staffRoleId: roleId
    }
  });

  return (
    <ComponentQueryLoader
      loading={roleDataLoading || staffUserCurrentLoading}
      hasData={roleData?.staffRole && staffUserCurrentData?.staffUserCurrent}
      error={roleDataError || staffUserCurrentError}
      hasDataComponent={
        <RoleDetail
          roleSubtype={staffUserCurrentData?.staffUserCurrent?.role?.roleSubtype ?? 'Staff.CaseWorker'}
          data={roleData?.staffRole as StaffRole}
          canEditRole={staffUserCurrentData?.staffUserCurrent?.role?.permissions?.rolePermissions?.canEditRoles ?? false}
        />
      }
    />
  );
};
